import i18n from '../../services/i18n/i18n'

const singleEventTranslation = i18n.get('Search.SingleEvent')
const multipleEventsTranslation = i18n.get('Search.Events')
const internationalEventsTranslation = i18n.get('Search.InternationalEvents')
const internationalSingleEventTranslation = i18n.get(
  'Search.SingleInternationalEvent'
)

/**
 * Get event count translation from result.
 * @param {Object} result
 */
export const eventCountTextFromResult = result => {
  let eventCountText = null
  const nationalEvents = Boolean(result.events.length)

  if (result.eventCount > 1) {
    eventCountText = multipleEventsTranslation
  } else if (result.eventCount === 1) {
    eventCountText = singleEventTranslation
  }

  if (result.eventCount > 1 && !nationalEvents) {
    eventCountText = internationalEventsTranslation
  } else if (result.eventCount === 1 && !nationalEvents) {
    eventCountText = internationalSingleEventTranslation
  }

  return Boolean(eventCountText) === true
    ? `${result.eventCount} ${eventCountText}`.toLowerCase()
    : null
}
